import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { styled } from 'styletron-react';
import { staticColors } from '../../const/colors/staticColors';
const StyledClickableRow = styled('tr', {
    cursor: 'pointer',
    ':hover': {
        backgroundColor: staticColors.dynamicTableRowHover,
    },
});
export const DynamicPinningTableRow = ({ children, isClickable, }) => {
    const [isRowHovered, setIsRowHovered] = useState(false);
    const onMouseEnter = () => setIsRowHovered(true);
    const onMouseLeave = () => setIsRowHovered(false);
    if (isClickable) {
        const clickableRowContent = children(isRowHovered);
        return (_jsx(StyledClickableRow, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, children: clickableRowContent }));
    }
    const staticRowContent = children(false);
    return _jsx("tr", { children: staticRowContent });
};
